import Threads from './Threads'
import ThreadDetail from './ThreadDetail'
import CreateThread from './CreateThread'

export default { Threads, ThreadDetail, CreateThread }
